import { Link, RouteObject } from 'react-router-dom';
import { twJoin } from '@utils/twMerge';
import { ReactNode } from 'react';
import { Label } from '@dynamika-shared/ui/Label/Label';

export type RoutesType = Array<RouteObject & { title: string }>;
export type ChildrenCreator = (r: RouteObject) => ReactNode;

type GenerateTabsItemsArgs = {
  routes: RoutesType;
  currentPathname: string;
  id?: string;
  children?: ChildrenCreator;
  extraText?: Record<string, string>;
  disableStyles?: boolean;
};

export const generateTabsItems = ({
  routes,
  currentPathname,
  id,
  children,
  extraText,
  disableStyles,
}: GenerateTabsItemsArgs) => {
  const defaultLinkClasses =
    'relative pb-[6px] h-2 flex items-center justify-center gap-1  whitespace-nowrap px-1 text-left text-[1.6rem] font-medium leading-6 tracking-normal hover:text-dodgerBlue';

  const getClassForPath = (currentPath: string, routePath: string) => {
    return currentPath === routePath.split('/').pop()
      ? 'text-dodgerBlue'
      : 'text-dimGray';
  };
  return routes.map(route => {
    return {
      key: (route?.path?.split('/') || []).pop() + '',
      label: (
        <Link
          className={twJoin(
            !disableStyles && [
              defaultLinkClasses,
              getClassForPath(currentPathname, route.path ?? ''),
            ]
          )}
          to={id ? route?.path?.replace(':id', id) ?? '' : route?.path ?? ''}
        >
          <div className={'flex'}>
            {route.title}{' '}
            {extraText?.[route.title] && (
              <Label className={'ms-1'}>{extraText?.[route.title]}</Label>
            )}
          </div>
          {children?.(route)}
        </Link>
      ),
    };
  });
};
